<template>
  <div class="p-6">
    <h2 class="text-lg font-semibold mb-5" :class="isDark ? 'text-white' : 'text-gray-800'">字符串长度</h2>

    <div class="space-y-4">
      <div>
        <label class="block text-xs font-medium mb-2" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
          输入字符串
        </label>
        <textarea
          v-model="input"
          rows="6"
          placeholder="在此输入要统计的字符串..."
          class="w-full px-3 py-2 rounded-md border text-sm font-mono resize-y focus:outline-none focus:ring-1 focus:ring-green-500"
          :class="isDark ? 'bg-gray-800 border-gray-700 text-white placeholder-gray-600' : 'bg-white border-gray-300 text-gray-800 placeholder-gray-400'"
        ></textarea>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div v-for="stat in stats" :key="stat.label"
             class="p-3 rounded-lg border text-center"
             :class="isDark ? 'bg-gray-800/50 border-gray-700' : 'bg-gray-50 border-gray-200'">
          <div class="text-[10px] mb-1" :class="isDark ? 'text-gray-500' : 'text-gray-400'">{{ stat.label }}</div>
          <div class="font-mono text-lg font-semibold" :class="isDark ? 'text-green-400' : 'text-green-600'">{{ stat.value }}</div>
        </div>
      </div>

      <div v-if="input" class="space-y-2">
        <div class="text-xs font-medium" :class="isDark ? 'text-gray-400' : 'text-gray-600'">详细统计</div>
        <div class="space-y-1 text-xs font-mono"
             :class="isDark ? 'text-gray-400' : 'text-gray-500'">
          <div v-for="detail in details" :key="detail.label" class="flex justify-between px-3 py-1.5 rounded-md"
               :class="isDark ? 'bg-gray-800/30' : 'bg-gray-50'">
            <span>{{ detail.label }}</span>
            <span :class="isDark ? 'text-green-400' : 'text-green-600'">{{ detail.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useTheme } from '../../composables/useTheme'

export default {
  name: 'StringLength',
  setup() {
    const { isDark } = useTheme()
    const input = ref('')

    const stats = computed(() => {
      const text = input.value
      const chars = text.length
      const bytes = new Blob([text]).size
      const lines = text ? text.split('\n').length : 0
      return [
        { label: '字符数', value: chars },
        { label: '字节数 (UTF-8)', value: bytes },
        { label: '行数', value: lines },
        { label: '单词数', value: countWords(text) }
      ]
    })

    const details = computed(() => {
      const text = input.value
      if (!text) return []
      const chars = text.length
      const charsNoSpace = text.replace(/\s/g, '').length
      const bytes = new Blob([text]).size
      const lines = text.split('\n').length
      const words = countWords(text)
      const sentences = text.split(/[。！？.!?]+/).filter(s => s.trim()).length
      const paragraphs = text.split(/\n\s*\n/).filter(s => s.trim()).length
      return [
        { label: '总字符数', value: chars },
        { label: '不含空格字符数', value: charsNoSpace },
        { label: 'UTF-8 字节数', value: bytes },
        { label: '行数', value: lines },
        { label: '单词数', value: words },
        { label: '句子数', value: sentences },
        { label: '段落数', value: paragraphs }
      ]
    })

    function countWords(text) {
      if (!text.trim()) return 0
      // 中文按字符算，英文按单词算
      const cjk = (text.match(/[\u4e00-\u9fa5\u3040-\u309f\u30a0-\u30ff]/g) || []).length
      const en = (text.replace(/[\u4e00-\u9fa5\u3040-\u309f\u30a0-\u30ff]/g, ' ').match(/[a-zA-Z0-9]+/g) || []).length
      return cjk + en
    }

    return { isDark, input, stats, details }
  }
}
</script>
